import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@pearsontechnology/aero-components';
import enhanceWithThemes from 'hocs/enhanceWithThemes';
import StyledLink from 'components/StyledLink';

import {
  EmptyStateWrapper,
  EmptyStateImageWrapper,
  MessageTitle,
  MessageBody,
  EmptyStateFooterWrapper,
  ButtonContainer,
} from './styles';
import themes from './themes';

const EmptyState = ({ showCreateCohortModal }) => (
  <EmptyStateWrapper>
    <EmptyStateImageWrapper />
    <MessageTitle>
        Teach with classes
    </MessageTitle>
    <MessageBody>
        Enroll students, schedule deployments, view insights, <br />
        and manage grades all in one place.
    </MessageBody>
    <EmptyStateFooterWrapper>
      <StyledLink to="#">How to use classes</StyledLink>
      <ButtonContainer>
        <Button primary onClick={showCreateCohortModal}>
          Create Class
        </Button>
      </ButtonContainer>
    </EmptyStateFooterWrapper>
  </EmptyStateWrapper>
);

EmptyState.propTypes = {
  showCreateCohortModal: PropTypes.func,
};

export default enhanceWithThemes(EmptyState, themes);
